import { tranfer_bank_to_hotel } from "@/constants/hotels";

export const getBanksByBrand = (brand: string): string[] => {
  const banks = [];
  for (const [key, value] of tranfer_bank_to_hotel.entries()) {
    if (value.includes(brand)) {
      banks.push(key);
    }
  }

  return banks;
};
